import React, { useId, useMemo } from 'react';
import { line } from 'd3-shape';
import { getWaveform, getMarkers } from '@/utils/ekg/waveforms';

export const EcgTrace = ({ pattern, lead, duration = 2.5, start = 0, annotated = true, testId }) => {
  const unique = useId().replaceAll(':', '');
  const width = duration * 150 + 90;
  const height = 204;
  const baseline = 114;
  const path = useMemo(() => line()
    .x(point => 78 + point.time * 150)
    .y(point => baseline - point.value * 60)(getWaveform(pattern.id, lead, duration, start)), [pattern.id, lead, duration, start]);
  const markers = annotated ? getMarkers(pattern.id, duration, start) : [];

  return (
    <svg data-testid={testId} className="ecg-trace" viewBox={`0 0 ${width} ${height}`} role="img" aria-labelledby={`${unique}-title ${unique}-desc`}>
      <title id={`${unique}-title`}>{pattern.title} – Ableitung {lead}, schematisches Lehrbeispiel</title>
      <desc id={`${unique}-desc`}>Ausschnitt {start.toFixed(1)} bis {(start + duration).toFixed(1)} Sekunden. Großes Rasterfeld: 0,2 Sekunden und 0,5 Millivolt. Keine Patientenaufzeichnung.</desc>
      <defs>
        <pattern id={`${unique}-small`} width="6" height="6" patternUnits="userSpaceOnUse">
          <path d="M 6 0 L 0 0 0 6" fill="none" stroke="#f5dddd" strokeWidth=".45" />
        </pattern>
        <pattern id={`${unique}-large`} width="30" height="30" patternUnits="userSpaceOnUse">
          <rect width="30" height="30" fill={`url(#${unique}-small)`} />
          <path d="M 30 0 L 0 0 0 30" fill="none" stroke="#eac1c1" strokeWidth=".8" />
        </pattern>
        <clipPath id={`${unique}-clip`}><rect x="76" width={width - 76} height={height} /></clipPath>
      </defs>
      <rect width={width} height={height} fill="#fffafa" />
      <rect width={width} height={height} fill={`url(#${unique}-large)`} />
      <path d={`M 14 ${baseline} h 8 v -60 h 30 v 60 h 10`} stroke="#788489" fill="none" strokeWidth="1.2" />
      <text x="14" y="43" fontSize="10" fill="#667479">1 mV</text>
      <line x1="78" x2={width - 6} y1={baseline} y2={baseline} stroke="#738a8c" strokeWidth=".6" strokeDasharray="3 4" />
      {markers.map((mark, index) => <g key={index}>
        <rect x={78 + mark.from * 150} y="46" width={(mark.to - mark.from) * 150} height="126" fill="#0a8a851b" />
        <text x={78 + mark.from * 150} y={index % 2 ? 32 : 20} fontSize="10" fill="#006c67">{mark.label}</text>
      </g>)}
      <path data-testid={`${testId}-path`} d={path} fill="none" stroke="#26383c" strokeWidth="1.65" strokeLinejoin="round" strokeLinecap="round" clipPath={`url(#${unique}-clip)`} />
      <text x="78" y="194" fontSize="10" fill="#667479">{start.toFixed(1)} s</text>
      <text x={width - 8} y="194" textAnchor="end" fontSize="10" fill="#667479">{(start + duration).toFixed(1)} s</text>
    </svg>
  );
};